import angular from 'angular';
import _ from 'lodash';

(function() {
    'use strict';
    angular.module('app.core').factory('OrdersDA', OrdersDA);

    OrdersDA.$inject = ['Restangular', 'OrderDetails', 'CONF', 'InvoiceAssociated'];

    function OrdersDA(Restangular, OrderDetails, CONF, InvoiceAssociated) {
        var version = 'v1';
        var baseUrl = 'orders';

        var exports = {
            searchOrders: searchOrders,
            getInvoicesAssociated: getInvoicesAssociated
        };

        return exports;

        /**
         * Recherche le détail des commandes suivant le filtre.
         */
        function searchOrders(filter) {
            return Restangular.oneUrl(CONF.apiBaseUrl)
                .oneUrl(version)
                .all(baseUrl)
                .all('search-details')
                .post(filter)
                .then(function(orders) {
                    orders.content = _.map(orders.content, function(order) {
                        return new OrderDetails(order);
                    });
                    return orders;
                });
        }

        /**
         * Récupère les factures créées à partir d'une commande.
         * guid : guid de la commande
         */
        function getInvoicesAssociated(guid) {
            return Restangular.oneUrl(CONF.apiBaseUrl)
                .oneUrl(version)
                .one(baseUrl, guid)
                .all('invoices')
                .customGET()
                .then(function(invoices) {
                    return _.map(invoices, function(invoice) {
                        return new InvoiceAssociated(invoice);
                    });
                });
        }
    }
})();
